define('lq/design/jqueryExtensions',[
    'jquery'
], function ($) {
    'use strict';

    var positionWithoutTransform = function () {
        var originalTtransform = this.css('transform');
        this.css('transform', '');
        //var result = this.position();
        var result = { top: this[0].offsetTop, left: this[0].offsetLeft };
        if (originalTtransform) {
            this.css('transform', originalTtransform);
        }
        return result;
    };
    
    var enterKey = function (callback) {
        return this.each(function () {
            $(this).on('keypress', function (ev) {
                var keycode = ev.keyCode ? ev.keyCode : ev.which;
                if (keycode === 13) callback.call(this, ev);
            });
        });
    };

    $.fn.extend({
        positionWithoutTransform: positionWithoutTransform,
        enterKey: enterKey
    });

    $.fn.naturalDimensions = function () {
        return this.map(function () {
            if (this.naturalWidth !== undefined) {
                return {
                    width: this.naturalWidth,
                    height: this.naturalHeight
                };
            }

            // fallback for older browsers (e.g. IE8 and lower)
            var inMemoryCopy = new Image();
            inMemoryCopy.src = $(this).attr('src');
            return {
                width: inMemoryCopy.width,
                height: inMemoryCopy.height
            };
        });
    };

});

